export default "__VITE_ASSET__DIpF9x2g__"